export default {
  SET_PENDING_QUOTATION(state, pending_quotations){
    state.pending_quotations = pending_quotations
  },
  SET_SUMAL_DASHBOARD(state, sumal_dashboard){
    state.sumal_dashboard = sumal_dashboard
  },
  SET_TRANSACTIONS_OCOL(state, transactionsocol){
    state.transactionsocol = transactionsocol
  },
  UPDATE_EFACTURA(state, { toBeSent, received }) {
    state.eFacturaToBeSent = toBeSent || 0;
    state.eFacturaReceived = received || 0;
  },
  UPDATE_FISCAL(state, { pending, indeterminate, vatGroups, agentBlocking, agent, z, register }) {
    // Etat de la CAISSE (IP changee, injoignable, hors mode 6), calcule serveur.
    state.fiscalRegister = register || null;
    // Rapport Z : dernier Z, Z oublie (overdue), Z au resultat inconnu.
    state.fiscalZ = z || null;
    state.fiscalPending = pending || 0;
    state.fiscalIndeterminate = indeterminate || 0;
    state.fiscalVatGroups = vatGroups || 0;
    state.fiscalAgentBlocking = !!agentBlocking;
    state.fiscalAgent = agent || null;
  },
  SET_OCOL_SUM(state, dashboardocolsum){
    state.dashboardocolsum = dashboardocolsum
  },
  SET_OCOL_LIST(state, dashboardocollist){
    state.dashboardocollist = dashboardocollist
  },
  SET_DASHBOARD_HARVESTING_TOTAL_ARCHIVED(state, dashboardharvestingtotalarchived){
    state.dashboardharvestingtotalarchived = dashboardharvestingtotalarchived
  },
  SET_DASHBOARD_HARVESTING_ARCHIVED(state, dashboardharvestingarchived){
    state.dashboardharvestingarchived = dashboardharvestingarchived
  },
  SET_DASHBOARD_HARVESTING_TOTAL_IN_PROGRESS(state, dashboardharvestingtotalinprogress){
    state.dashboardharvestingtotalinprogress = dashboardharvestingtotalinprogress
  },
  SET_DASHBOARD_HARVESTING_IN_PROGRESS(state, dashboardharvestinginprogress){
    state.dashboardharvestinginprogress = dashboardharvestinginprogress
  },
  SET_UNPAID_INVOICE_PROVIDER_SUM (state, unpaidinvoiceprovidersum) {
    state.unpaidinvoiceprovidersum = unpaidinvoiceprovidersum
  },
  SET_UNPAID_INVOICE_PROVIDER (state, unpaidinvoiceprovider) {
    state.unpaidinvoiceprovider = unpaidinvoiceprovider
  },
  SET_LIST_FOR_EXISTING_TRANSPORT(state, existingtransport)
  {
    state.existingtransport = existingtransport
  },
  CREATE_NEW_TRANSPORT (state, transportnew) {
    state.transportnew = transportnew
  },
  SET_TRANSPORTWAITINGFORDEPARTURE (state, transportwaitingfordeparture) {
    state.transportwaitingfordeparture = transportwaitingfordeparture
  },
  SET_TRANSPORTWAITINGFORDEPARTUREENTRANT (state, transportwaitingfordepartureentrant) {
    state.transportwaitingfordepartureentrant = transportwaitingfordepartureentrant
  },
  SET_TRANSPORTTODAY (state, transporttoday) {
    state.transporttoday = transporttoday
  },
  SET_TRANSPORTENTRANTTODAY (state, transportentranttoday) {
    state.transportentranttoday = transportentranttoday
  },
  SET_TRANSPORTONTHEROAD (state, transportontheroad) {
    state.transportontheroad = transportontheroad
  },
  SET_TRANSPORTONTHEROADENTRANT (state, transportontheroadentrant) {
    state.transportontheroadentrant = transportontheroadentrant
  },
  SET_TRANSPORT (state, transport) {
    state.transport = transport
  },
  SET_VALUE_UNPAID_INVOICE (state, valueunpaidinvoice) {
    state.valueunpaidinvoice = valueunpaidinvoice
  },
  SET_UNPAID_INVOICE (state, unpaidinvoice) {
    state.unpaidinvoice = unpaidinvoice
  },
  SET_VOLUME_TOTAL (state, quotationvolumetotal) {
    state.quotationvolumetotal = quotationvolumetotal
  },
  SET_QUOTATION_DASHBOARD_PRODUCT_PRINT (state, quotation_dashboard_product_print) {
    state.quotation_dashboard_product_print = quotation_dashboard_product_print
  },
  SET_QUOTATION_DASHBOARD_PRODUCT_PRINT_v2 (state, quotation_dashboard_product_print_v2) {
    state.quotation_dashboard_product_print_v2 = quotation_dashboard_product_print_v2
  },
  SET_QUOTATION_DASHBOARD_PRODUCT_PRINT_v3 (state, quotation_dashboard_product_print_v3) {
    state.quotation_dashboard_product_print_v3 = quotation_dashboard_product_print_v3
  },
  SET_QUOTATION_DASHBOARD (state, quotation_dashboard) {
    state.quotation_dashboard = quotation_dashboard
  },
  SET_QUOTATION_DASHBOARD_PRODUCT (state, quotation_dashboard_product) {
    state.quotation_dashboard_product = quotation_dashboard_product
  },
  SET_KPI (state, kpi) {
    state.kpi = kpi
  },
  SET_SOLAR_STATIONS (state, solarStations) {
    state.solarStations = solarStations
  },
  SET_SOLAR_REALTIME (state, solarRealtime) {
    state.solarRealtime = solarRealtime
  },
  SET_SOLAR_HISTORY (state, solarHistory) {
    state.solarHistory = solarHistory
  },
  SET_SOLAR_HISTORY_DAY (state, solarHistoryDay) {
    state.solarHistoryDay = solarHistoryDay
  },
  SET_SOLAR_FORECAST (state, solarForecast) {
    state.solarForecast = solarForecast
  },
  SET_SOLAR_SCORES (state, payload) {
    state.solarScores = (payload && payload.items) || []
    state.solarWorstScore = (payload && payload.worst) || null
  },
  SET_SOLAR_CRITICAL_ALERTS (state, payload) {
    state.solarCriticalAlerts = {
      count: (payload && payload.count) || 0,
      criticalCount: (payload && payload.criticalCount) || 0,
      warningCount: (payload && payload.warningCount) || 0,
      items: (payload && payload.items) || [],
    }
  }
}
 